import About from "../componets/About/About";
import {AnimatePresence, motion } from "framer-motion";

export default function AboutPage() {

  return (
    <AnimatePresence mode="wait">
      <motion.div
        variants={{
          hidden: { opacity: 0, y: -20 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate="visible"
        transition={{ duration: 1.2, ease: "easeInOut" }}
        className="h-auto bg-[#d7c0ae] text-black"
        
      >
        <About />
      </motion.div>
    </AnimatePresence>
  );
}
